/* LPM · Vidéo fournisseur (snippet lpm-video, 28/10/2026) : le voile lance et met en pause le lecteur YouTube
   par l'API postMessage ; aucun clic n'atteint le lecteur, donc aucun lien vers YouTube. */
(function () {
  if (window.lpmVideo) return;
  window.lpmVideo = true;

  function commande(iframe, nom) {
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: nom, args: [] }), '*');
    }
  }

  function ecouter(iframe) {
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(JSON.stringify({ event: 'listening' }), '*');
    }
  }

  function etat(bloc, lecture) {
    bloc.classList.toggle('is-lecture', lecture);
    var voile = bloc.querySelector('.lpm-video-voile');
    if (voile) voile.setAttribute('aria-label', lecture ? 'Mettre la vidéo en pause' : 'Lire la vidéo');
  }

  document.querySelectorAll('[data-lpm-video] iframe').forEach(function (iframe) {
    iframe.addEventListener('load', function () { ecouter(iframe); });
  });

  document.addEventListener('click', function (e) {
    var voile = e.target.closest && e.target.closest('.lpm-video-voile');
    if (!voile) return;
    e.preventDefault();
    var bloc = voile.closest('[data-lpm-video]');
    var iframe = bloc.querySelector('iframe');
    ecouter(iframe);
    if (bloc.classList.contains('is-lecture')) {
      commande(iframe, 'pauseVideo');
      etat(bloc, false);
    } else {
      commande(iframe, 'playVideo');
      etat(bloc, true);
    }
  });

  // Le lecteur renvoie son état (1 = lecture) : le voile suit la fin de la vidéo ou une pause.
  window.addEventListener('message', function (e) {
    if (!/^https:\/\/www\.youtube(-nocookie)?\.com$/.test(e.origin) || typeof e.data !== 'string') return;
    var d;
    try { d = JSON.parse(e.data); } catch (err) { return; }
    if (!d || !d.info || typeof d.info.playerState !== 'number') return;
    document.querySelectorAll('[data-lpm-video]').forEach(function (bloc) {
      var iframe = bloc.querySelector('iframe');
      if (iframe && iframe.contentWindow === e.source) etat(bloc, d.info.playerState === 1);
    });
  });
})();
